var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.995 7.934a.75.75 0 10-1.06 1.06L10.938 12l-3.005 3.005a.75.75 0 101.06 1.06L12 13.06l3.005 3.006a.75.75 0 101.06-1.06L13.062 12l3.005-3.005a.75.75 0 00-1.06-1.061L12 10.939 8.995 7.934z",
    fill: "#000"
  })));
}

export default SvgClose;